
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDuctGoingTo as ObiDuctGoingToElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-duct-going-to.js';
 
 
 

 
 export const ObiDuctGoingTo = createComponent({
   react: React,
   tagName: 'obi-duct-going-to',
   elementClass: ObiDuctGoingToElement,
   events: {
     
   }
  });
 
 